
ADILF.define('adilf/apps/social/util/google-analytics',['require','exports','module','streamhub-sdk/jquery','adilf/debug','adilf/context','adilf/handler','adilf/util/utils','auth'],function (require, exports, module) {/* HSSN-2678: Temporary metrics for Comments */
"use strict";

var jquery = require('streamhub-sdk/jquery');
var Debug = require('adilf/debug');
var Context = require('adilf/context');
var Handler = require('adilf/handler');
var utils = require('adilf/util/utils');
var auth = require('auth');

var GoogleAnalytics = function(conf) {
    if(!conf) { conf = {}; }
    this.conf = conf;

    var name = 'GoogleAnalytics'+this.conf.name;
    Handler.apps[name] = this;

    this.debug = new Debug(name);

    if(this.conf.prefix) {
        this.eventNamePrefix = this.conf.prefix;        
    }
    if(this.conf.category) {
        this.category = this.conf.category;        
    }
};

GoogleAnalytics.prototype.eventNamePrefix = "sports_temp_";

GoogleAnalytics.prototype.category = "sports";

GoogleAnalytics.prototype.track = function(eventName) {
    var adiTrackEvent = {
        action: this.en(eventName),
        category: this.category,
        label: this.conf.label
    };
    if(window.adiTrack) {
        this.debug.print("Tracking event:", adiTrackEvent);
        window.adiTrack.event(adiTrackEvent);
    } else {
        this.debug.warn("adiTrack library is not present to track event:", adiTrackEvent);
    }
};

GoogleAnalytics.prototype.en = function(eventShortName) { // en = "event name", I don't wanna type
    return this.eventNamePrefix + "_" + eventShortName;
};

GoogleAnalytics.prototype.registerEvent = function(conf) {
    var self = this;
    this.debug.print("Registering event:", conf);
    jquery(conf.scope).on(conf.eventName, conf.selector, function (e) {
        var eventName;
        if(typeof conf.gaEventName === 'function') {
            eventName = conf.gaEventName(e);
        } else {
            eventName = conf.gaEventName;
        }
        if(conf.auth) {
            eventName = eventName + "_" + ((auth.isAuthenticated()) ? "loggedin" : "loggedout");
        }
        if(eventName) {
            self.track(eventName);
        } else {
            self.debug.print("eventName undefined");
        }
    });
};

module.exports = GoogleAnalytics;
});
